<template>
  <div class="home-box">
    <gSwiperCommon :bannerType="'show.page.home.pc'"></gSwiperCommon>
    <div class="home-content">
      <div class="home">
        <liveModule></liveModule>
        <div class="g-layout">
          <div class="g-layout-l">
            <navTab v-if="isOpenTabs"></navTab>
            <div class="m-card" v-if="exhibitionId !== '6d9aa6f0-aa0b-4523-9b16-6ee8307b628c' && enabledSupplyDemand">
              <div class="mc-top">
                <div class="mc-top-title">
                  <span class="mc-top-txt s-bold s-primary">免费发布供需</span>
                </div>
              </div>
              <publicDemand></publicDemand>
            </div>

            <cateModule></cateModule>

            <!-- <peopleModule></peopleModule> -->

            <otherExModule></otherExModule>

            <!-- <contact-module></contact-module> -->

            <visitModule></visitModule>
          </div>
          <div class="g-layout-r">
            <!-- 国药励展定制 -->
            <brandExModule2 v-if="exhibitionId === '6d9aa6f0-aa0b-4523-9b16-6ee8307b628c'"></brandExModule2>

            <!-- 品牌展商 -->
            <brandExModule></brandExModule>

            <div class="g-layout2 s-nobottom" v-if="demandTotalCount || demandTotalCount2">
              <div class="g-layout2-l">
                <demandModule @setCount="setCount"></demandModule>
              </div>
              <div class="g-layout2-r">
                <demandModule2 @setCount="setCount2"></demandModule2>
              </div>
            </div>

            <!-- 热搜产品 -->
            <hotProduct></hotProduct>

            <!-- 同期活动 -->
            <time-activity></time-activity>

            <!-- 为您推荐 -->
            <topicProduct></topicProduct>

            <div class="g-layout2" v-if="totalCount || totalCount2">
              <div class="g-layout2-l">
                <more-video @setCount="setCount3"></more-video>
              </div>
              <div class="g-layout2-r">
                <!-- 为您推荐 -->
                <news-module @setCount="setCount4"></news-module>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import gSwiperCommon from "@components/gSwiperCommon/gSwiperCommon.vue";
import publicDemand from "@components/public-demand";
import liveModule from "./components/live-module.vue";
import peopleModule from "./components/people-module.vue";
import brandExModule from "./components/brand-ex-module.vue";
import brandExModule2 from "./components/brand-ex-module2.vue";
import demandModule from "./components/demand-module.vue";
import demandModule2 from "./components/demand-module2.vue";
import topicProduct from "./components/topic-product";
import hotProduct from "./components/hot-product";
import timeActivity from "./components/time-activity";
import moreVideo from "./components/more-video";
import newsModule from "./components/news-module";
import contactModule from "./components/contact-module";
import visitModule from "./components/visit-module";
import cateModule from "./components/cate-module";
import otherExModule from "./components/other-ex-module";
import navTab from "./components/tab-module";

export default {
  name: "home",
  data () {
    return {
      demandTotalCount: 1,
      demandTotalCount2: 1,
      totalCount: 1,
      totalCount2: 1,
    };
  },
  components: {
    gSwiperCommon,
    publicDemand,
    liveModule,
    peopleModule,
    brandExModule,
    brandExModule2,
    demandModule,
    demandModule2,
    demandModule2,
    topicProduct,
    hotProduct,
    timeActivity,
    moreVideo,
    newsModule,
    contactModule,
    visitModule,
    otherExModule,
    cateModule,
    navTab,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      exhibitionConfig: "getExhibitionConfig",
      token: "getToken",
      login: "getLogin",
      exhibitionConfig: "getExhibitionConfig",
    }),
    isOpenTabs () {
      return this.exhibitionConfig && this.exhibitionConfig.display.enabledCustomQuick;
    },
    enabledSupplyDemand () {
      return this.exhibitionConfig && this.exhibitionConfig.feature && this.exhibitionConfig.feature.enabledSupplyDemand;
    },
  },
  created () {
    document.title = this.exhibitionInfo ? this.exhibitionInfo.name : "展商秀";
    this.setShare();
    if (this.login) {
      this.getMember();
    }
  },
  methods: {
    ...mapActions({
      getShareConfig: "share/getShareConfig",
      graphqlPost: "graphqlPost",
    }),
    ...mapMutations({
      setUser: "setUser",
      setUserId: "setUserId",
      setToken: "setToken",
    }),
    async setShare () {
      let data = await this.getShareConfig({ id: this.exhibitionId, name: "share.exhibition.config" });
      let share = {
        url: location.href,
        title: this.exhibitionInfo.name,
        desc: this.exhibitionInfo.name,
        summary: this.exhibitionInfo.remark,
        pics: this.exhibitionInfo.logo,
      };
      if (data) {
        let dataJson = JSON.parse(data);
        if (dataJson.content) {
          share.title = dataJson.content;
        }
        if (dataJson.des) {
          share.desc = dataJson.des;
          share.summary = dataJson.des;
        }
      }
      this.$store.commit("setShare", share);
    },
    linkTo (e) {
      if (e && e.url) {
        window.open(e.url);
      }
    },
    setCount (e) {
      this.demandTotalCount = e;
    },
    setCount2 (e) {
      this.demandTotalCount2 = e;
    },
    setCount3 (e) {
      this.totalCount = e;
    },
    setCount4 (e) {
      this.totalCount2 = e;
    },
    async getMember () {
      let query = `
        query{
          memberQuery{
            current{
              address
              avatarUrl
              balance
              birthday
              businessCard
              city
              company
              country
              county
              createAt
              deleteAt
              department
              email
              followCount
              id
              inMember(exhibitionId:"${this.exhibitionId}"){ 
                business
                category
                id 
                memberId
                originId
                originLang
                originRemark
                isBlacklist
                originType
                regAt
                sayCount
                sayUserCount
                userId
                userRole
                exhibitorId
                companyUsers{
                  id
                  isAppointment
                }
              }
              introduction
              isDeleted
              jobTitle
              name
              nickName
              phone
              phoneConfirm
              province
              talkCount
              talkSuccessedCount
              title
              updateAt
              userId
            }
          } 
        }
      `;
      let opt = {
        opt: {
          query: query,
        },
        token: this.token,
      };
      let data = await this.graphqlPost(opt);
      if (data.data && data.data.memberQuery) {
        this.setUser(data.data.memberQuery.current);
        this.setUserId(data.data.memberQuery.current.userId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/my-theme/mixin.scss";

.home-content {
  position: relative;

  &::before {
    position: absolute;
    z-index: 1;
    content: "";
    top: -20px;
    left: 50%;
    margin-left: -50%;
    height: 200px;
    width: 100%;
    @include background_image(#8badd1);
    background-blend-mode: normal, normal;
  }
}

.home {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  .m-imglist {
    max-height: 122px;
    overflow: hidden;
  }

  .m-card {
    margin-bottom: 10px;

    .m-list3 .ml3-txt {
      max-width: 100%;
    }

    .u-brand2 {
      flex-shrink: 0;
    }
  }

  .g-layout .g-layout-l {
    width: 310px;
  }

  .g-layout .g-layout-r {
    margin-left: 10px;
    flex-shrink: 0;
    width: 880px;
  }

  .g-layout2 .g-layout2-r {
    min-height: 220px;
  }

  .m-list .ml-item-l {
    width: auto;
  }
}
</style>
